import {
  themeActions,
  validSession,
  envSwitch,
  IMG_COLLECTION_STATUS,
  loadingObject,
  captureFlowScreen,
  imageScreen,
} from '../../../utils/config';
import * as types from './types';
import { reducerPhotoCodeReverse } from '~/utils/photoCode';
import { map } from 'lodash';

const initialState = {
  env: envSwitch.DEV || envSwitch.PRODUCTION,
  valid: validSession.NONE,
  loadingAnimated: loadingObject,
  retakeArray: [],
  is_retake: false,
  item: {
    theme: '',
  },
  camera: {},
  capture: {},
  sessionKey: '',
  status: null,
  dealerName: null,
  isRender: true,
  arrImages: [],
  isCheckingReport: {
    state: true,
    from: '',
  },
  invalidWarning: null,
};

const session = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_SESSION:
      return {
        ...state,
        item: action.payload,
      };
    case types.SET_SESSION_STATUS:
      return {
        ...state,
        status: action.data.status,
        invalidWarning: action.data.status === 'invalid_warning' ? action.data.status_reason : null
      };
    case types.SET_INVALID_WARNING:
      return {
        ...state,
        invalidWarning: action.warningType,
      };
    case types.CLEAR_INVALID_WARNING:
      return {
        ...state,
        invalidWarning: null,
      };
    case types.CHECKING_REPORT_DAMAGES:
      return {
        ...state,
        isCheckingReport: action.status,
      };
    // SHOULD-UPDATE: support custom flow screen data
    case types.DECLARE_DATA_FLOW:
      let appTemp = [];
      const customFlow = action.payload.custom || [];
      switch (action.payload.type) {
        case themeActions.PAVE_PLATE_LEFT:
          appTemp = captureFlowScreen.plateLeft;
          break;
        case themeActions.PAVE_PLATE_RIGHT:
          appTemp = captureFlowScreen.plateRight;
          break;
        case themeActions.PAVE_REAR_TIRE:
          appTemp = captureFlowScreen.rearTire;
          break;
        case themeActions.PAVE_CAPT:
        case 'CUSTOM':
          appTemp = (action.payload.custom || []).map(String);
          break;
        default:
          if (customFlow.length > 0) {
            appTemp = customFlow.map(String);
          } else {
            appTemp = captureFlowScreen.default;
          }
          break;
      }

      appTemp = map(appTemp, (screen) => {
        return {
          key: screen,
          value: imageScreen[screen] || null,
          defaultStatus: 'DE',
          is_retake: false,
          percent: 0,
          imgSize: '',
        };
      });

      // console.log('DEBUG: DECLARE_DATA_FLOW >> appTemp', appTemp);

      return {
        ...state,
        arrImages: appTemp,
      };
    case types.LOADING_ANIMATE:
      return {
        ...state,
        loadingAnimated: { ...action.loadingType },
      };

    case types.SAVE_SESSION_KEY:
      return {
        ...state,
        sessionKey: action.key,
        item: {
          theme: action.key.substring(0, 3),
        },
      };

    case types.COLLECT_IMAGE:
      const image = action.image;
      const newArr = [...state.arrImages];
      const defaultStatus = image.defaultStatus;
      const is_retake = image.is_retake;
      const photoCode = image.photo_code;
      const imgSize = image.imgSize;
      const position = image.position;
      for (let i = 0; i < newArr.length; i++) {
        if (parseInt(photoCode) === newArr[i].key) {
          if (defaultStatus === IMG_COLLECTION_STATUS.DE) {
            if (image.img.length > 0) {
              newArr[i].value = image.img;
            }
            newArr[i].defaultStatus = defaultStatus;
            newArr[i].is_retake = is_retake;
            newArr[i].imgSize = imgSize;
            newArr[i].position = position;
          } else if (defaultStatus === IMG_COLLECTION_STATUS.AC) {
            if (image.img.length > 0) {
              newArr[i].value = image.img;
            }
            newArr[i].defaultStatus = defaultStatus;
            newArr[i].position = position;
          } else {
            newArr[i].defaultStatus = defaultStatus;
          }
        }
      }
      return {
        ...state,
        arrImages: newArr,
      };

    case types.SET_RENDER:
      return {
        ...state,
        isRender: false,
      };

    case types.MAP_IMAGES:
      const getNewArr = action.array;
      const getCurrentArr = state.arrImages;
      const resultArr =
        !!getCurrentArr &&
        getCurrentArr.map((e) => {
          let temp =
            !!getNewArr &&
            getNewArr.find(
              (element) => reducerPhotoCodeReverse(element.photo_code) === e.key
            );
          if (!!temp) {
            e.value = temp.cdn_url;
            e.defaultStatus = IMG_COLLECTION_STATUS.AC;
          }
          return e;
        });
      return {
        ...state,
        arrImages: resultArr,
      };

    case types.RETAKE_ARRAY:
      return {
        ...state,
        retakeArray: action.retakeArray,
      };

    case types.RESET_SESSION:
      return initialState;

    default:
      return state;
  }
};
export default session;
